var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Listagem de regiões prazo entrega")]),_c('div',[_c('b-table',{attrs:{"hover":"","items":_vm.regioesPrazoEntrega,"fields":_vm.fields},scopedSlots:_vm._u([{key:"cell(id)",fn:function(data){return [_c('router-link',{attrs:{"to":'/rotaPrazoEntrega/edit/' + data.value}},[_vm._v(_vm._s(data.value))])]}}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }